/* istanbul ignore file */
/* eslint-disable */
import React from 'react';

const ImagesIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.95876 13.7079C3.26205 13.8932 3.61856 14 4 14H7.46667M2.95876 13.7079C2.82291 13.6249 2.69774 13.5262 2.58579 13.4142C2.22386 13.0523 2 12.5523 2 12V10.6667M2.95876 13.7079L6 10.6667M14 9.33333L13.0237 8.35702C11.7219 7.05528 9.61139 7.05528 8.30964 8.35702L6 10.6667M14 9.33333V4C14 2.89543 13.1046 2 12 2H11.3333M14 9.33333V12C14 13.1046 13.1046 14 12 14H7.33333M6 10.6667L4.94281 9.60948C4.42211 9.08878 3.57789 9.08878 3.05719 9.60948L2 10.6667M2 10.6667V4C2 2.89543 2.89543 2 4 2H8.66667M7 5.66667C7 6.40305 6.40305 7 5.66667 7C4.93029 7 4.33333 6.40305 4.33333 5.66667C4.33333 4.93029 4.93029 4.33333 5.66667 4.33333C6.40305 4.33333 7 4.93029 7 5.66667Z"
      stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default ImagesIcon;
